<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">error</i>

      <h1 class="headline">Cannot Revoke</h1>
      <p>
        Your credentials are no longer valid. They may have expired.
      </p>

      <p>
        Please try again by clicking on the revocation link in the email you
        received.
      </p>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons">close</i>
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {};
</script>



// WEBPACK FOOTER //
// src/components/Home/RevokeModal/RevokeModalTokenError.vue